import { Textarea } from "../ui/textarea";
import { Field } from "../Field";
import { Segmented } from "../Segmented";
import { TextField } from "./StepCustomer";
import { todayISO } from "../../lib/api";

const LOCATION_TYPES = [
  { value: "residence", label: "Residence", id: "residence" },
  { value: "mechanic", label: "Mechanic", id: "mechanic" },
  { value: "business", label: "Business", id: "business" },
  { value: "other", label: "Other", id: "other" },
];

const StopFields = ({ k, title, form, set, errors }) => {
  const s = form[k];
  const zipChange = (v) => set(k, "zip")(v.replace(/\D/g, "").slice(0, 5));
  return (
    <fieldset className="border border-slate-200 p-5 grid sm:grid-cols-6 gap-4" data-testid={`reg-${k}-fieldset`}>
      <legend className="px-2 font-display uppercase tracking-wider font-bold text-brand-600">{title}</legend>
      <TextField id={`${k}.address`} label="Street address *" value={s.address} onChange={set(k, "address")} error={errors[`${k}.address`]} className="sm:col-span-4" />
      <TextField id={`${k}.zip`} label="ZIP *" value={s.zip} onChange={zipChange} error={errors[`${k}.zip`]} className="sm:col-span-2" inputProps={{ inputMode: "numeric", className: "field-input font-mono" }} />
      <TextField id={`${k}.contact_name`} label="Contact name *" value={s.contact_name} onChange={set(k, "contact_name")} error={errors[`${k}.contact_name`]} className="sm:col-span-3" />
      <TextField id={`${k}.contact_phone`} label="Contact phone *" type="tel" value={s.contact_phone} onChange={set(k, "contact_phone")} error={errors[`${k}.contact_phone`]} className="sm:col-span-3" />
      {k === "delivery" && (
        <Field id="delivery.location_type" label="Delivery location type" className="sm:col-span-6" hint="Delivering to a mechanic or shop for a pre-acceptance check costs no extra.">
          <Segmented value={s.location_type} onChange={set("delivery", "location_type")} options={LOCATION_TYPES} testid="reg-location-type" />
        </Field>
      )}
    </fieldset>
  );
};

export const StepRoute = ({ form, set, errors }) => (
  <div className="space-y-6" data-testid="reg-step-route">
    <StopFields k="pickup" title="Pickup" form={form} set={set} errors={errors} />
    <StopFields k="delivery" title="Delivery" form={form} set={set} errors={errors} />
    <div className="grid sm:grid-cols-3 gap-5">
      <TextField id="pickup_date" label="Preferred pickup date *" type="date" value={form.pickup_date} onChange={set(null, "pickup_date")} error={errors.pickup_date} inputProps={{ min: todayISO(), className: "field-input [color-scheme:light]" }} />
      <Field id="notes" label="Notes (optional)" className="sm:col-span-2">
        <Textarea id="notes" rows={3} value={form.notes} onChange={(e) => set(null, "notes")(e.target.value)} placeholder="Gate codes, low clearance, timing constraints…"
          className="rounded-none bg-white border-slate-300 focus-visible:ring-amber-500" data-testid="reg-input-notes" />
      </Field>
    </div>
  </div>
);
